/**
 * Directus SDK client — minimal setup.
 *
 * We use `@directus/sdk` only for its `createDirectus().with(rest())` composition;
 * all authenticated calls go through `authFetch()` in `./auth.ts` which manages
 * tokens manually. This matches the adview_system pattern: the SDK is handy for
 * typed item access but the auth middleware it ships with is too opaque for
 * debugging 401/refresh flows.
 */
import { createDirectus, rest } from "@directus/sdk";

export const DIRECTUS_URL =
  import.meta.env.VITE_DIRECTUS_URL?.replace(/\/$/, "") || "http://localhost:8444";

/**
 * The bare Directus SDK client. Use this only for non-auth operations or when
 * you need a typed helper like `readItems()`. For most code paths, use `authFetch`.
 */
export const directus = createDirectus(DIRECTUS_URL).with(rest());
